const getters = {
    getTitle: (state, getters) => {
        return state.title;
    },
    getMenuType: (state, getters) => {
        return state.menuTypes;
    },
    getSelectTab: (state, getters) => {
        return state.selectTab;
    },
    getPayStatus: (state, getters) => {
        return state.payStatus;
    },
    getErrorMessage: (state, getters) => {
        return state.errorMessage;
    },
    getMemberScoreType: (state, getters) => {
        return state.memberScoreType;
    },
    getFansBy: (state, getters) => {
        return state.fansBy;
    },
    getRankBy: (state, getters) => {
        return state.rankBy;
    },
    getShowFooter: (state, getters) => {
        return state.showFooter;
    }
};

export default getters;


// WEBPACK FOOTER //
// ./src/getters/interface.js